export default __webpack_public_path__ + "static/media/02.5620d2a1.jpg";